<template>
    <Page>
        <KBackButton />
        <div v-if="course?.id" class="row mt-5 mb-3">
            <div class="col-12">
                <div class="c-line kd-header-full">
                    <div class="header-top-title">Corso</div>
                    <div class="row">
                        <div class="col-12 col-md-8 col-lg-12">
                            <h3 class="title-text">
                                {{ course.title }}
                            </h3>
                        </div>
                    </div>
                    <K3ColContainer rowClass="m-0" col1Class="p-1" col2Class="p-1" col3Class="p-1">
                        <template #col1>
                            <p class="header-sub-detail m-0">Durata</p>
                            <p>{{ course.totalHours }} ore</p>
                        </template>
                    </K3ColContainer>
                </div>
            </div>
        </div>
        <div class="col-12 d-flex justify-content-between mb-3 position-relative">
            <h3 class="m-0">In partenza</h3>

            <a @click="goToPreRegistrationPage()" class="btn btn-xs btn-icon p-0" role="button">
                <KIcon class="icon-primary" icon="it-calendar" />
                <span class="ml-4 text-primary">RICHIEDI PRE-ISCRIZIONE</span>
            </a>
        </div>
        <div class="col-12">
            <DataTable :value="startingCourses" dataKey="id" responsiveLayout="scroll" :loading="loading">
                <Column header="DATA INIZIO">
                    <template #body="slotProps">
                        {{ toDateString((slotProps.data as CourseInstance).startDate) }}
                    </template>
                </Column>
                <Column header="ISCRITTI">
                    <template #body="slotProps">
                        {{ slotProps.data.subscribedNumber }}
                    </template>
                </Column>
                <Column header="DISPONIBILITA'" >
                    <template #body="slotProps">
                        {{ slotProps.data.studentsNumber - slotProps.data.subscribedNumber }}
                    </template>
                </Column>
                <Column >
                    <template #body="slotProps">
                        <div style="text-align: right">
                            <button type="button" @click="goToSubscriptionPage(slotProps.data.id)" class="btn btn-primary"> ISCRIVITI </button>
                        </div>
                    </template>
                </Column>

                <template #empty> Nessun corso in partenza trovato, puoi richiedere la pre-iscrizione </template>
            </DataTable>
        </div>
    </Page>
</template>

<script setup lang="ts">
import { onMounted, ref, computed } from "vue";
import { useCourseStore } from "../store";
import { useRouter, useRoute } from "vue-router";
import { CourseTemplate } from "@/learning/Templates/Models";
import { CourseInstance, CourseInstanceFinder } from "@/learning/instances/models";
import { CourseInstanceWrapper } from "../../../services/learningWrappers/Models";
import { useFilters } from "@k-digitale/kappa"

const router = useRouter();
const { toDateString } = useFilters();
const route = useRoute();
const courseStore = useCourseStore();

const course = ref<CourseTemplate>({} as CourseTemplate)
const startingCourses = ref<CourseInstanceWrapper[]>([])

const loading = ref<boolean>(false);

const idCourse = computed( () => {
    let id = route.params.id as unknown as string;
    if(id){
        return id;
    }
    return "";
})


const courseInstanceFinder = ref<CourseInstanceFinder>({
 pageIndex: -1,
 pageSize: -1,
} as CourseInstanceFinder)

onMounted(async () => {
    loading.value = true;
    course.value = await courseStore.getCourse(idCourse.value);
    courseInstanceFinder.value.courseTemplateId = course.value.id;
    startingCourses.value = await courseStore.getStartingCoursesWrapper(courseInstanceFinder.value);
    loading.value = false;

});

const goToSubscriptionPage = (id: string) => {
    router.push({ name: 'course-registration', params: { id: id } });
}
const goToPreRegistrationPage = () => {
    router.push({ name: 'course-pre-registration', params: { id: course.value.id } });
}

</script>

<style lang="scss">
.go-to-course-accordion {
    top: 19px;
    right: 70px;
}

.kd-header-full {
    margin: -20px -30px -20px;
    padding: 20px;
    color: #333333;
    background-color: #f4f4f4;
}

.course-state-code {
    width: 10px;
    height: 10px;
    border-radius: 5px;
}
</style>
